import { getText } from '@/lib/i18n/i18n.server';
import { Text } from '@/decodo/components/atoms/Text';
import { ArticleItemStrapi } from '@/decodo/components/organisms/relatedArticles/RelatedArticleItemStrapi';
import { cms } from '@/cms';
import { cn } from '@/lib/utils';

export interface BlogOverviewProps {
  articleSlugs: string[];
}

export const BlogOverview = async ({ articleSlugs }: BlogOverviewProps) => {
  const data = await cms.getLatestBlogpost();
  const latestBlogpost = data?.data?.[0]?.attributes;
  const texts = await getText();

  if (!latestBlogpost) {
    return null;
  }

  return (
    <div className='md:dark:bg-gray-dark-900 w-full md:grid md:grid-cols-5 md:rounded md:border md:border-gray-200 md:p-6 md:shadow-md'>
      <div className='w-full pb-8 md:col-span-3 md:pr-6'>
        <Text
          color='gray-950'
          variant='h3'
          classNames={{
            wrapper: 'text-left pb-6 font-serif',
          }}
        >
          {texts.blog_overview.most_recent}
        </Text>

        {latestBlogpost.slug && (
          <div
            className={cn(
              'grid gap-8 md:grid-cols-2 md:gap-x-9 md:gap-y-12',
              'md:grid md:grid-cols-1'
            )}
          >
            <ArticleItemStrapi slug={latestBlogpost.slug} />
          </div>
        )}
      </div>
      <div className='md:dark:border-gray-dark-600 scrollbar dark:scrollbar-dark md:col-span-2 md:max-h-[566px] md:w-full md:overflow-y-scroll md:border-l md:border-gray-200 md:pl-6 md:pr-[14px]'>
        <Text
          color='gray-950'
          variant='h3'
          classNames={{ wrapper: 'pb-6 text-left text-subitle-l font-serif' }}
        >
          {texts.blog_overview.most_popular}
        </Text>
        {articleSlugs.map((articleSlug) => (
          <div className='overflow-x-hidden pb-6 pt-1' key={articleSlug}>
            <ArticleItemStrapi slug={articleSlug} size='small' />
          </div>
        ))}
      </div>
    </div>
  );
};
